import React, { useContext, Suspense, useCallback, useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import MultiSelect from "react-multiple-select-dropdown-lite";
import store from "../redux_store/store";
import { Servicecalls } from "../custom_functions/Functions";
import { CreateDialog } from "./Dialog";
import { t } from 'react-multi-lang';
export const ProjectTeam = (props: any) => {
  const [preselectedSite, setPreselectedSite] = useState<any[]>([]);
  const [options, setOptions] = useState<any[]>([]);
  const [selectedteam, setSelectedTeam] = useState<any[]>([]);
  const [usersteam , setUsersteam] = useState<any[]>([]);

  const ELNurl = (window as any).appUrl.ELN || "";

  useEffect(() => {
    const fetchProjectTeams = () => {
    let passObjDet  = {
        lssitemaster : store.getState().Loggeduser.lssitemaster,
        lsusermaster : store.getState().Loggeduser
    }
    
      Servicecalls(
       `${ELNurl}/User/GetLoggedUsersTeamSitewise`, // Replace with the actual endpoint
        passObjDet,
        (response: any) => {
          console.log("Response:", response);

          setUsersteam(response);
          const mappedOptions = response.map((team: any) => ({
            label: team.teamname, // Text to display in the dropdown
            value: team.teamcode, // Unique identifier for the dropdown
          }));

          setOptions(mappedOptions);
        },
        (error: any) => {
          console.error("Error fetching project teams:", error);
        }
      );
    };

    fetchProjectTeams(); // Trigger the API call on component mount
  }, []);

  const onprojectteamchange = (val:any) => {
    console.log(val);
    let lstteam = val.split(",");
    setSelectedTeam(lstteam);
    props.onprojectteamchange({
        selectedteam : lstteam,
        usersteam : usersteam
    })
  }
  
  return (
    <>
      {props.isshowtosite === 3 ? (
        <div className="form-group">
          <label className="required">{t("Setup.Projectteam.IDS_LBL_PROJECTTEAM")}</label>
          <Suspense fallback={<div>Loading...</div>}>
            <MultiSelect
              placeholder={t("Setup.Projectteam.IDS_LBL_PROJECTTEAM")}
              options={options}
              defaultValue={preselectedSite}
              style={{
                width: "100%",
              }}
              onChange={onprojectteamchange}

            />
          </Suspense>
        </div>
      ) : null}
       
    </>
  );
};
